import React, {useEffect, useState, useRef} from "react"
import styled from 'styled-components'
import {animate,AnimationOptions,motion,MotionStyle,PanInfo,useMotionValue} from "framer-motion"
import {IosArrowRight} from '@styled-icons/fluentui-system-filled/IosArrowRight'
import {IosArrowLeft} from '@styled-icons/fluentui-system-filled/IosArrowLeft'

const transition = {
  type: "spring",
  bounce: 0,
}

const Carousel = ({
  children,
  renderArrowLeft,
  renderArrowRight,
  renderDots,
  autoPlay = true,
  interval = 5000,
  loop = true,
  arrowsContainer = null,
  arrowLeftPadding = null,
  arrowRightPadding = null
}) => {

  const x = useMotionValue(0);
  const containerRef = useRef(null)
  const [index, setIndex] = useState(0)
  const calculateNewX = () => -index * (containerRef.current?.clientWidth || 0)

  const handleEndDrag = (e, dragProps) => {
    const clientWidth = containerRef.current?.clientWidth || 0
    const { offset } = dragProps

    if (offset.x > clientWidth / 4) handlePrev()
    else if (offset.x < -clientWidth / 4) handleNext()
    else animate(x, calculateNewX(), transition)
  }

  const childrens = React.Children.toArray(children)

  const handleNext = () => {
    const idx = loop ? 0 : index;
    setIndex(index + 1 === childrens.length ? idx : index + 1)
  }

  const handlePrev = () => {
    const idx = loop ? childrens.length - 1: 0;
    setIndex(index - 1 < 0 ? idx : index - 1)
  }

  useEffect(() => {
    const controls = animate(x, calculateNewX(), transition)
    return controls.stop
  }, [index])

  useEffect(() => {
    if (!autoPlay) {
        return
    }
    const timer = setInterval(() => handleNext(), interval)
    return () => clearInterval(timer)
  }, [handleNext, interval])

  return (
    <Wrapper ref={containerRef}>
      
      {childrens.map((child, i) => (
        <Slider 
          as={motion.div}
          onDragEnd={handleEndDrag} 
          key={i}
          index={i}
          drag="x"
          dragElastic={0.3}
          style={{x}}
        >
          {child}
        </Slider>
      ))}

      {/* left arrow */}
      {renderArrowLeft ? (
        renderArrowLeft({ handlePrev, activeIndex: index })
      ) : (
        <Arrow 
          left 
          leftPadding={arrowLeftPadding} 
          onClick={handlePrev}
        >
          <IosArrowLeft />
        </Arrow>
      )}

      {/* right arrow */}
      {renderArrowRight ? (
        renderArrowRight({ handleNext, activeIndex: index })
      ) : (
        <Arrow 
          left={false} 
          leftPadding={arrowLeftPadding} 
          onClick={handleNext}
          >
          <IosArrowRight />
        </Arrow>
      )}

      {/* dots */}
      {/* {renderDots ? (
        renderDots({ setActiveIndex: setIndex, activeIndex: index })
      ) : (
        <Dots>
          {new Array(childrens.length).fill("").map((_, i) => (
            <span
              onClick={() => setIndex(i)}
              key={i}
              style={{
                background: i === index ? "#FFF" : "rgba(255,255,255,0.4)",
                transform: `scale(${i === index ? 1.3 : 1})`,
              }}
            ></span>
          ))}
        </Dots>
      )} */}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
`

const Overlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.2);
`

const Slider = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  display: inline-block;
  flex: none;
  left: ${({index}) => `${index * 100}%`};
  right: ${({index}) => `${index * 100}%`};
`

const Arrow = styled.div`
  position: absolute;
  z-index: 10;
  width: 32px;
  height: 32px;
  background-color: #171717;
  top: 50%;
  transform: translateY(-50%);
  /* border-radius: 50%; */
  color: #FFF;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  left: ${({left, leftPadding}) => left ? `${leftPadding ? 15 + leftPadding : 7}px` : 'initial'};
  right: ${({left, leftPadding}) => !left ? `${leftPadding ? 15 + leftPadding : 7}px` : 'initial'};

  svg {
    width: 15px;
  }
`

const Dots = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);

  span {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: 0 10px;
    display: inline-block;
    cursor: pointer;
  }
`

export default Carousel;